module.exports = {
    "crude": {
        "search": "Söka",
        "actions": "Handlingar",
        "nextPage": "Nästa sida",
        "lastPage": "Föregående sida",
        "back": "Tillbaka",
        "empty": "tömma",
        "edit": "redigera",
        "create": "skapa",
        "data": "spela in",
        "view": "show",
        "delete": "Radera",
        "save": "Spara",
        "cancel": "Annullera",
        "noContent": "Inga poster tillgängliga. ",
        "resetFilter": "Återställ filtren och se mer innehåll!",
        "createOwnTextField": "Skapa ditt eget textfält",
        "textFieldName": "textfältetikett",
        "textFieldValue": "Innehåll",
        "insertTextFieldLabel": "Vänligen ange textfältets namn!",
        "deleteTextField": "Ta bort textfält",
        "success": "Spara lyckades",
        "invalidDataFields": "Följande datafält är ogiltiga:  ",
        "entries": "poster",
        "entry": "inträde",
        "tabDetail": "detaljer",
        "entity": "entitet",
        "of": "från",
        "uploadNewFile": "Ladda upp fil",
        "upload": "ladda upp",
        "confirm": "OK",
        "deleteFileQuestion": "Vill du verkligen ta bort den här filen? ",
        "deleteFileQuestionTitle": "Fara!",
        "deleteEntityQuestion": "Vill du verkligen ta bort den här enheten? ",
        "deleteEntityQuestionTitle": "Fara!",
        "errorLargeFileUpload": "Den valda filen är för stor!",
        "useCroppedImage": "Använd gröda",
        "useOriginalImage": "Använd originalbild",
        "available": "tillgängliga",
        "searchColumn": "hitta kolumn",
        "manageColumns": "Hantera kolumner",
        "hideColumn": "dölj kolumnen",
        "pinToRight": "Fäst kolumnen till höger",
        "pinToLeft": "Fäst kolumn till vänster",
        "sortAsc": "Sortera stigande",
        "sortDesc": "Sortera fallande",
        "hideAll": "dölja allt",
        "showAll": "Visa allt",
        "preview": "förhandsvisning",
        "title": "titel",
        "description": "Beskrivning",
        "tooltip": "verktygstips",
        "sort": "sortera efter",
        "settings": "inställningar",
        "incomingReference": "referens",
        "language": "Språk",
        "deleteTabQuestionTitle": "Fara!",
        "deleteTabQuestion": "Vill du verkligen ta bort den här fliken? ",
        "deleteElementQuestionTitle": "Fara!",
        "deleteElementQuestion": "Vill du verkligen ta bort det här objektet? ",
        "configurationEditorDescriptionStringLayout": "I den här kolumnen kan tre varianter väljas för att skriva in texten:",
        "configurationEditorDescriptionEnumLayout": "Två varianter kan väljas för valet av elementen i denna kolumn:",
        "configurationEditorDescriptionBooleanLayout": "Två varianter kan väljas för valet av elementen i denna kolumn:",
        "configurationEditorDescriptionForeignEntityLayout": "Två varianter kan väljas för valet av elementen i denna kolumn:",
        "stringLayoutsingleline": "en kö",
        "stringLayoutmultiline": "flerlinje",
        "stringLayouteditor": "Rich Text Editor",
        "enumLayoutradio": "Radio knapp",
        "enumLayoutdropdown": "falla ner",
        "booleanLayoutcheckbox": "kryssruta",
        "booleanLayoutswitch": "växlar",
        "foreignEntityLayoutpopUp": "dyka upp",
        "foreignEntityLayoutautocomplete": "falla ner",
        "foreignEntityLayoutlist": "lista",
        "formatTooltipbold": "Fett",
        "formatTooltipitalic": "kursiv",
        "formatTooltipunderline": "understruken",
        "formatTooltipstrike": "Struken",
        "formatTooltipclean": "tydlig formatering",
        "formatTooltipcodeBlock": "koda",
        "formatTooltipblockquote": "Citat",
        "formatTooltipcolor": "fontfärg",
        "formatTooltipbackground": "bakgrundsfärg",
        "formatTooltipfont": "font",
        "formatTooltipalign": "inriktning",
        "formatTooltipheader": "textstorlek",
        "formatTooltipsuper": "Exponent",
        "formatTooltipsub": "index",
        "formatTooltipordered": "Beställd lista",
        "formatTooltipbullet": "Uppräkning",
        "true": "Ja",
        "false": "Nej",
        "selectEntity": "välj enhet",
        "filter": "filtrera",
        "useFilter": "Använd filter",
        "defaultFilter": "återställ filtret",
        "expand": "bygga ut",
        "hide": "Dölj",
        "minimumSelectionError": "Minst {{min}} poster måste väljas.",
        "maximumSelectionError": "Högst {{max}} poster kan väljas."
    }
}
;